/**
 * Brand marks for the email-client preview tabs.
 *
 * Path data is the official artwork from Simple Icons (https://simpleicons.org),
 * which publishes it under CC0-1.0. Only brands Simple Icons still carries are
 * vendored here — Microsoft and Yahoo were withdrawn from that set following
 * trademark requests, so those clients use a generic glyph plus a brand accent
 * colour rather than an approximated logo.
 *
 * Same shape as the repo's other inline brand SVGs (see dnd-social-icons.ts):
 * a viewBox-24 filled path drawn in `currentColor`, so the surrounding CSS
 * controls both size and tint. Note these are solid fills, unlike the stroked
 * lucide icons they sit beside.
 */

interface BrandIconProps {
  className?: string;
  'aria-hidden'?: boolean | 'true' | 'false';
}

const GMAIL_PATH =
  'M24 5.457v13.909c0 .904-.732 1.636-1.636 1.636h-3.819V11.73L12 16.64l-6.545-4.91v9.273H1.636A1.636 1.636 0 0 1 0 19.366V5.457c0-2.023 2.309-3.178 3.927-1.964L5.455 4.64 12 9.548l6.545-4.91 1.528-1.145C21.69 2.28 24 3.434 24 5.457z';

const APPLE_PATH =
  'M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701';

function BrandSvg({ path, ...rest }: BrandIconProps & { path: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" {...rest}>
      <path d={path} />
    </svg>
  );
}

export function GmailIcon(props: BrandIconProps) {
  return <BrandSvg path={GMAIL_PATH} {...props} />;
}

export function AppleIcon(props: BrandIconProps) {
  return <BrandSvg path={APPLE_PATH} {...props} />;
}
